import { makeAutoObservable } from 'mobx';
import { validateMfeRetracement } from './validateMfeRetracement';

export class MfeRetracementData {
  mfeType = 'byPnl'; //drop down options: byPositionPrice, byPnl
  retraceType = 'expanding'; //dont show to users, this is for future implementations
  activateSetting = 'PERCENT'; //options: PERCENT, AMOUNT. notes: If mfeType === position price, this must be a percentage. if mfeType==byPnl, this can be either pct or amount
  pnlType = 'OVERALL'; //options: OVERALL, UNREALIZED. notes: only selectable if mfeType===byPnl
  retracePct = 50; //pct to retrace from max mfe
  activationValue = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'retracePct') {
          this.retracePct = Number(initialData.retracePct) * 100;
        } else if (
          field === 'activationValue' &&
          initialData.activateSetting === 'PERCENT'
        ) {
          this.activationValue = Number(initialData.activationValue) * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  resetToDefaults = () => {
    this.mfeType = 'byPnl';
    this.retraceType = 'expanding';
    this.activateSetting = 'PERCENT';
    this.pnlType = 'OVERALL';
    this.retracePct = 50;
    this.activationValue = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateMfeRetracement(this);
    return result;
  };
  returnJson = () => {
    return {
      mfeType: this.mfeType,
      retraceType: this.retraceType,
      activateSetting: this.activateSetting,
      pnlType: this.pnlType,
      retracePct: Number(this.retracePct) / 100,
      activationValue:this.activateSetting === 'PERCENT' ? Number(this.activationValue) / 100 : this.activationValue,
    };
  };

  //specific methods
  setMfeType = (string) => {
    if(string === 'byPositionPrice'){
      this.activateSetting = 'PERCENT';
    }
    this.mfeType = string;
  };
  setRetraceType = (string) => {
    this.retraceType = string;
  };
  setActivateSetting = (string) => {
    this.activateSetting = string;
  };
  setPnlType = (string) => {
    this.pnlType = string;
  };
  setRetracePct = (number) => {
    this.retracePct = number;
  };
  setActivationValue = (number) => {
    this.activationValue = number;
  };
}
